module.exports = __webpack_public_path__ + "img/zip.a0eea906.svg";